import React, { useState, useRef } from 'react';

function Ready({ onNavigate }) {
  const [noOffset, setNoOffset] = useState({ x: 0, y: 0 });
  const noWrapperRef = useRef(null);
  const offsetRef = useRef({ x: 0, y: 0 });
  offsetRef.current = noOffset;

  const handleMouseMove = (e) => {
    const wrapper = noWrapperRef.current;
    if (!wrapper) return;
    const { x, y } = offsetRef.current;
    const rect = wrapper.getBoundingClientRect();
    const btnCenterX = rect.left + rect.width / 2 + x;
    const btnCenterY = rect.top + rect.height / 2 + y;
    const mouseX = e.clientX;
    const mouseY = e.clientY;
    const dist = Math.hypot(btnCenterX - mouseX, btnCenterY - mouseY);
    const fleeRadius = 140;
    if (dist < fleeRadius && dist > 0) {
      const dx = (btnCenterX - mouseX) / dist;
      const dy = (btnCenterY - mouseY) / dist;
      const fleeDist = fleeRadius - dist;
      setNoOffset(prev => ({
        x: prev.x + dx * fleeDist,
        y: prev.y + dy * fleeDist,
      }));
    }
  };

  return (
    <div className="dashboard" onMouseMove={handleMouseMove}>
      <div className="home__center startup__stack">
        <span className="secretpin__title">Ready?</span>
        <div className="ready__buttons">
          <button
            type="button"
            className="dashboard__button dashboard__button--primary home__button"
            onClick={() => onNavigate?.('countdown')}
          >
            Yes
          </button>
          <div ref={noWrapperRef} className="ready__no-wrapper">
            <button
              type="button"
              className="dashboard__button dashboard__button--primary home__button"
              style={{
                transform: `translate(${noOffset.x}px, ${noOffset.y}px)`,
              }}
            >
              No
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Ready;
